type Props = {
  count: number;
  singular: string;
  plural: string;
}

export default function pluralFormatter({ count, singular, plural }: Props) {
  return count > 1 ? plural : singular;
}
